"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var CloseCallBack;
var ContinueCallBack;
exports.LsbSetupRender = function (ele, continueCallBack, closeCallBack) {
    CloseCallBack = closeCallBack;
    ContinueCallBack = continueCallBack;
    ReactDOM.render(React.createElement(LsbSetup, null), ele);
    $("#divLsbSetup").modal("show");
    l.DTM.push({
        type: 'eSupportProcess_Complete',
        name: 'LSB:Need install',
        action: 'Button Click'
    });
};
exports.LsbSetupClose = function () {
    if ($("#divLsbSetup").is(":visible")) {
        $("#divLsbSetup").modal("hide");
    }
};
var LsbSetup = /** @class */ (function (_super) {
    __extends(LsbSetup, _super);
    function LsbSetup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new LSBSetupModel();
        _this.state.IsFirstStepOver = false;
        _this.NotAgree = _this.NotAgree.bind(_this);
        _this.Agree = _this.Agree.bind(_this);
        return _this;
    }
    LsbSetup.prototype.componentWillReceiveProps = function () {
        l.DTM.push({
            type: 'eSupportProcess_Complete',
            name: 'LSB:Not Agree',
            action: 'Button Click'
        });
        this.state.IsFirstStepOver = false;
    };
    LsbSetup.prototype.componentDidMount = function () {
        var that = this;
        //load config
        $.ajax({
            type: "GET",
            url: l.UrlUtility.getFullServicesPath("/Lsb/GetSupportConfig"),
            data: { id: "ACF31E27-3CC1-4A09-A1CF-54B1253351B9" },
            dataType: "JSON",
            success: function (data) {
                that.state.AskedContent = data.ValueStatementOrDiagram;
                that.state.TermsContent = data.TermsAndConditionsContent;
                that.state.InstallationMsg = data.DetectConfig.Instructions;
                that.state.LsbLocation = data.DetectConfig.Location;
                that.state.MinVersion = data.DetectConfig.Version;
                that.setState(that.state);
            }
        });
    };
    LsbSetup.prototype.componentDidUpdate = function () {
        //update toggle button click-event
        $('.faq-toggle').unbind();
        $('.faq-toggle').click(function () {
            $('.faq-box').slideToggle(200);
        });
    };
    LsbSetup.prototype.NotAgree = function () {
        $("#divLsbSetup").modal("hide");
        if (CloseCallBack) {
            CloseCallBack();
        }
        l.DTM.push({
            type: 'eSupportProcess_Complete',
            name: 'LSB:Not Agree',
            action: 'Button Click'
        });
        this.state.IsFirstStepOver = false;
    };
    LsbSetup.prototype.Agree = function () {
        this.state.IsFirstStepOver = true;
        this.setState(this.state);
        l.DTM.push({
            type: 'eSupportProcess_Complete',
            name: 'LSB:Agree',
            action: 'Button Click'
        });
        window.setTimeout(function () {
            window.open($("#lsbDownload").attr("href"));
        }, 0);
        if (ContinueCallBack) {
            ContinueCallBack();
        }
    };
    LsbSetup.prototype.render = function () {
        var _this = this;
        var processBarProModel = new LSBSetupModel();
        processBarProModel.IsFirstStepOver = this.state.IsFirstStepOver;
        return (React.createElement("div", null,
            React.createElement("div", { className: "modal fade dow-lsb-setup", id: "divLsbSetup", "data-backdrop": "static" },
                React.createElement("div", { className: "modal-dialog" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-body" },
                            React.createElement(LsbTitle, null),
                            React.createElement(LsbProcessBar, __assign({}, processBarProModel)),
                            (function () {
                                if (!_this.state.IsFirstStepOver) {
                                    return (React.createElement("div", null,
                                        React.createElement("div", { className: "dow-lsb-asked-questions", dangerouslySetInnerHTML: { __html: _this.state.AskedContent } }),
                                        React.createElement("div", { className: "dow-lsb-terms-and-conditions" },
                                            React.createElement("div", { className: "dow-lsb-terms-title", id: "termsTitle" }, l.Translator.translate("terms and conditions title")),
                                            React.createElement("div", { className: "dow-lsb-conditions", dangerouslySetInnerHTML: { __html: _this.state.TermsContent } }))));
                                }
                                else {
                                    return (React.createElement("div", null,
                                        React.createElement("div", { className: "dow-lsb-process-installation-container" },
                                            React.createElement("img", { src: "/msa/driver/images/pcg/loader.gif", className: "loadingImg" }),
                                            React.createElement("div", { className: "dow-lsb-downloading" }, l.Translator.translate("lsb downloading")),
                                            React.createElement("p", null,
                                                l.Translator.translate("Your download will start within 5 seconds"),
                                                React.createElement("a", { href: _this.state.LsbLocation, id: "lsbDownload" },
                                                    React.createElement("span", { id: "awindowopen" }, l.Translator.translate("click here"))),
                                                "...            "))));
                                }
                            })()),
                        React.createElement("div", { className: "modal-footer dow-lsb-buttons" },
                            React.createElement("a", { className: "btn btn-default", onClick: this.NotAgree }, l.Translator.translate("Cancel")),
                            !this.state.IsFirstStepOver ? React.createElement("a", { className: "btn btn-primary", onClick: this.Agree }, l.Translator.translate("Continue")) : ""))))));
    };
    return LsbSetup;
}(React.Component));
//https://download.lenovo.com/lsb/LSBsetup.exe
var LsbTitle = /** @class */ (function (_super) {
    __extends(LsbTitle, _super);
    function LsbTitle(props) {
        return _super.call(this, props) || this;
    }
    LsbTitle.prototype.render = function () {
        return (React.createElement("div", { className: "dow-lsb-title" },
            React.createElement("img", { alt: "Lenovo Service Bridge", src: "/msa/driver/images/pcg/Lsb_icon.png" }),
            React.createElement("div", { className: "dow-lsg-title-name" }, l.Translator.translate("Lenovo Service Bridge")),
            React.createElement("strong", null,
                React.createElement("br", null),
                l.Translator.translate("lsb description"))));
    };
    return LsbTitle;
}(React.Component));
var LSBSetupModel = /** @class */ (function () {
    function LSBSetupModel() {
        this.IsFirstStepOver = false;
        this.AskedContent = "";
        this.TermsContent = "";
        this.InstallationMsg = "";
        this.LsbLocation = "";
        this.MinVersion = "";
    }
    return LSBSetupModel;
}());
var LsbProcessBar = /** @class */ (function (_super) {
    __extends(LsbProcessBar, _super);
    function LsbProcessBar(props) {
        return _super.call(this, props) || this;
    }
    LsbProcessBar.prototype.render = function () {
        var firstStepClass = this.props.IsFirstStepOver ? "col-md-6 dow-lsb-process-bar-item dow-process-bar-item-left" : "col-md-6 dow-lsb-process-bar-item dow-process-bar-item-current";
        var secondStepClass = this.props.IsFirstStepOver ? "col-md-6 dow-lsb-process-bar-item dow-process-bar-item-current" : "col-md-6 dow-lsb-process-bar-item dow-process-bar-item-right";
        return (React.createElement("div", { className: "row dow-lsb-process-bar" },
            React.createElement("div", { className: firstStepClass },
                React.createElement("span", null, l.Translator.translate("Terms and Conditions"))),
            React.createElement("div", { className: secondStepClass },
                React.createElement("span", null, l.Translator.translate("Download and Install")))));
    };
    return LsbProcessBar;
}(React.Component));
